import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4 md:mb-8">
      <div>
        {eyebrow && (
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
            {eyebrow}
          </span>
        )}
        <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm text-foreground-500">{description}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden shrink-0 items-center gap-1 text-sm font-medium text-primary-700 transition-colors hover:text-accent-600 md:flex"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}